import * as transforms from './transforms'

const transform = (object, transformId) => {
  if (!transformId) {
    return object
  }

  try {
    return transforms[transformId](object)
  } catch (error) {
    console.warn(error)
    return object
  }
}

export default transform



// WEBPACK FOOTER //
// ./src/transforms/index.js